import React from "react";

const LoomIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3334 9.07332H13.4598L17.6805 6.6364L16.7537 5.03054L12.5328 7.46735L14.9692 3.24693L13.3632 2.31944L10.927 6.53986V1.66667H9.07306V6.5404L6.63582 2.31944L5.03039 3.2465L7.4672 7.46692L3.24635 5.03043L2.3194 6.63597L6.54014 9.07278H1.66663V10.9269H6.53971L2.3194 13.3635L3.24635 14.9695L7.46666 12.5331L5.02996 16.7535L6.63571 17.6805L9.07252 13.4596V18.3333H10.9265V13.46L13.3628 17.6805L14.9686 16.7535L12.5318 12.5326L16.7527 14.9695L17.6796 13.3635L13.4593 10.9271H18.3324V9.07343L18.3334 9.07332ZM9.9999 12.5214C8.60203 12.5214 7.46893 11.3884 7.46893 9.99044C7.46893 8.59256 8.60203 7.45947 9.9999 7.45947C11.3978 7.45947 12.5308 8.59256 12.5308 9.99044C12.5308 11.3884 11.3978 12.5215 9.9999 12.5215V12.5214Z",
  fill: "#625DF5"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LoomIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;